// extracted by mini-css-extract-plugin
module.exports = {"root":"_2sQCV","category":"Rq9LE"};